var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.width,
        height: _vm.height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M12.6017 5.27176L12.0018 6.60435L19.5662 22.3993H24.0005V14.5066V9.2478L21.6007 7.4127L21.0008 4.35421L18.0011 3.74251L16.2013 1.60156L12.6017 2.82496V5.27176Z",
          fill: "#EEA71F"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M0.0255852 20.5637H21.6007V15.0324L18.4492 15.1355L12.6549 5.79297L0.0255852 15.0324V20.5637Z",
          fill: "#E1503C"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M10.8136 12.7227H14.5892V10.7227H10.8136V12.7227Z",
          fill: "#E1503C"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M1.10443 15.6104H19.9827V14.6104H1.10443V15.6104Z",
          fill: "#E1503C"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M0.00259209 16.8938H18.4938L21.5708 14.2248L12.6012 5.27148L0.00259209 14.8529V16.8938Z",
          fill: "#E1503C"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M0.00292969 20.5645H24.0003V22.3995H0.00292969V20.5645Z",
          fill: "#EEA71F"
        }
      }),
      _vm._v(" "),
      _c(
        "mask",
        {
          staticStyle: { "mask-type": "alpha" },
          attrs: {
            id: "mask0_1001_11609",
            maskUnits: "userSpaceOnUse",
            x: "0",
            y: "5",
            width: "22",
            height: "11"
          }
        },
        [
          _c("path", {
            attrs: {
              d:
                "M0.00193787 15.0587H20.6167L21.8344 13.9759L12.6006 5.27148L0.00193214 14.8529L0.00193787 15.0587Z",
              fill: "#E1503C"
            }
          })
        ]
      ),
      _vm._v(" "),
      _c("g", { attrs: { mask: "url(#mask0_1001_11609)" } }, [
        _c("path", {
          attrs: {
            d:
              "M2.07739 12.667L4.03828 10.6676L10.9395 17.7042L8.97863 19.7036L2.07739 12.667Z",
            fill: "#EEA71F"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M14.6469 5.88281L16.3063 8.14822L3.46098 17.93L1.80157 15.6646L14.6469 5.88281Z",
            fill: "#EEA71F"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M20.0461 8.33008L21.7055 10.5955L8.86027 20.3772L7.20087 18.1118L20.0461 8.33008Z",
            fill: "#EEA71F"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M7.20117 9.10547L9.16206 7.10613L18.2015 16.3228L16.2406 18.3222L7.20117 9.10547Z",
            fill: "#EEA71F"
          }
        })
      ]),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M1.27246 17.1121L1.87246 16.6621L2.42 17.3922H3.14508L3.69262 16.6621L4.29262 17.1121L3.52008 18.1422H2.045L1.27246 17.1121Z",
          fill: "black"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M9.4651 18.6746L8.69256 19.7047H7.21749L6.44495 18.6746L7.04495 18.2246L7.59249 18.9547H8.31756L8.8651 18.2246L9.4651 18.6746Z",
          fill: "black"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M13.5127 16.573L14.1127 16.123L14.6602 16.8531H15.3853L15.9329 16.123L16.5329 16.573L15.7603 17.6031H14.2852L13.5127 16.573Z",
          fill: "black"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M17.4905 18.7957L18.0905 18.3457L18.638 19.0758H19.3631L19.9106 18.3457L20.5106 18.7957L19.7381 19.8258H18.263L17.4905 18.7957Z",
          fill: "black"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M21.5957 15.5908H0V14.5908H21.5957V15.5908Z",
          fill: "black"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M16.5759 3.43652V5.11897L15.2687 6.45175L14.7333 5.92659L15.8259 4.81257V3.43652H16.5759Z",
          fill: "black"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M19.5753 5.88379V7.56624L18.2681 8.89901L17.7327 8.37386L18.8253 7.25983V5.88379H19.5753Z",
          fill: "black"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M22.575 9.55371V11.2362L21.2679 12.5689L20.7324 12.0438L21.825 10.9298V9.55371H22.575Z",
          fill: "black"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M21.1413 14.6463L19.1068 12.599L19.6388 12.0703L21.6733 14.1176L21.1413 14.6463Z",
          fill: "black"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M17.1338 10.6585L15.3783 8.86781L15.9139 8.34277L17.6694 10.1335L17.1338 10.6585Z",
          fill: "black"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M11.9142 14.6283L10.1587 12.8375L10.6943 12.3125L12.4498 14.1032L11.9142 14.6283Z",
          fill: "black"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M13.4211 6.9016L12.1802 5.60436L12.7222 5.08594L13.963 6.38318L13.4211 6.9016Z",
          fill: "black"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M8.23257 10.8498L6.9917 9.5526L7.53367 9.03418L8.77455 10.3314L8.23257 10.8498Z",
          fill: "black"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M3.22598 14.6399L1.98511 13.3426L2.52708 12.8242L3.76796 14.1215L3.22598 14.6399Z",
          fill: "black"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }